import React from 'react'

const Office365Icon = () => {
	return (
		<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 200 239.766'>
			<path
				fill='#ea3e23'
				d='m200 219.785-.021-.012V20.591L128.615 0 .322 48.172 0 48.234l.016 144.023 43.78-17.134V57.943l84.819-20.279-.012 172.285L.088 192.257l128.515 47.456v.053l71.376-19.753v-.227z'
			/>
		</svg>
	)
}

export default Office365Icon
